<template>
  <div>
    <a-form-model :model="countData" :rules="rules" ref="ruleForm" :label-col="{ span: 8 }" :wrapper-col="{ span: 24 }">
      <div id="myCal">
        <!-- 保费试算 -->
        <div class="title_">
          <div class="cutleft_ order">保费试算</div>
          <div class="cutleft_ policy">险种信息</div>
          <div class="cutoff_"></div>
        </div>
        <a-row class="changeStyle_">
          <a-col :span="18">
            <div class="form_item">
              <a-form-model-item :label-col="{ span: 9 }" label="起止日期">
                <a-date-picker :disabled-date="disabledDate" :disabled="disabledAll" :showTime="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }" placeholder="开始日期" v-model="countData.effectiveDate" @change="effectiveDateChange" @ok="busDatehander" />
                <a-date-picker :showTime="{ defaultValue: moment('23:59:59', 'HH:mm:ss') }" style="margin-left: 20px" disabled v-model="applicantInfoExpireDate" placeholder="结束日期" />
              </a-form-model-item>
            </div>
            <div class="form_item">
              <a-form-model-item :label-col="{ offset: 2 }" label="选择月份">
                <a-radio-group name="radioGroup" v-model="countData.bracket">
                  <a-radio v-for="(item, i) in monthOptions" :key="i" :value="item.value">{{ item.name }}</a-radio>
                </a-radio-group>
              </a-form-model-item>
            </div>
          </a-col>
          <a-col :offset="2" :span="4" class="calRight_">
            <div class="calTxt_">保费合计</div>
            <div class="calmoney_">¥ {{ premiumSum }}</div>
          </a-col>
        </a-row>
        <div class="risk_">
          <div class="flex_">
            <div class="form_item">
              <a-form-model-item ref="occupationcodesh" :prop="!disabledAll ? 'occupationcodesh' : ''" :label-col="{ span: 12 }" label="营业性质">
                <a-select placeholder="请选择" :disabled="disabledAll" style="width: 280px" :value="countData.occupationcodesh" class="select_" @change="value => changeData(value, 'occupationcodesh')">
                  <a-select-option v-for="item in YYXZOptions" :key="item.value + 'occupationcodesh'" :value="item.value">{{ item.name }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </div>
            <div class="form_item">
              <a-form-model-item ref="area" :prop="!disabledAll ? 'area' : ''" :label-col="{ span: 12 }" label="营业面积">
                <a-input-number :disabled="disabledAll" :min="0" :max="5000" style="width: 280px" v-model="countData.area" @blur="e => changeData(e.target.value, 'area')" placeholder="请填写营业面积（平米）" />
                <span style="color: #fe8f2d">&nbsp;&nbsp;&nbsp;营业面积不超过5000平米</span>
              </a-form-model-item>
            </div>
          </div>
        </div>
      </div>
      <div class="risk_">
        <div class="flex_">
          <p class="p-header">主险</p>
          <!-- 公众责任险保额（每次事故及累计赔偿限额） -->
          <div class="form_item">
            <a-form-model-item ref="main0001" class="aftertext" :prop="!disabledAll ? 'main0001' : ''" :label-col="{ span: 12 }" label="公众责任险保额（每次事故及累计赔偿限额）">
              <a-input-number :disabled="disabledAll" :min="500000" :max="30000000" :step="500000" style="width: 280px" v-model="countData.main0001" @blur="e => changeData(e.target.value, 'main0001')" placeholder="请填写保额" />
            </a-form-model-item>
          </div>
          <p class="p-header">加费扩展条款</p>
          <!-- 契约责任扩展条款B(每次事故及累计赔偿限额：50万) -->
          <div class="form_item">
            <a-form-model-item :prop="!disabledAll ? 'main0003' : ''" :label-col="{ span: 12 }" label="每人赔偿限额">
              <a-radio-group :disabled="disabledAll" name="radioGroup" v-model="countData.main0003">
                <a-radio :value="countData.main0001">同主险</a-radio>
                <a-radio value="200000">20万</a-radio>
                <a-radio value="500000" v-if="countData.main0001 > 500000">50万</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </div>
          <div class="form_item">
            <a-form-model-item :label-col="{ span: 12 }" label="契约责任扩展条款B(每次事故及累计赔偿限额：50万)">
              <a-select placeholder="请选择" :disabled="disabledAll" style="width: 280px" class="select_" :value="countData.add0004" @change="value => changeData(value, 'add0004')">
                <a-select-option v-for="item in QYZRBoptions" :key="item.value + 'add0004'" :value="item.value">{{ item.name }}</a-select-option>
              </a-select>
              <span style="color: #fe8f2d">&nbsp;&nbsp;&nbsp;加收保费50元</span>
            </a-form-model-item>
          </div>
          <!-- 车辆装卸责任条款（每次事故及累计赔偿限额：10万） -->
          <div class="form_item">
            <a-form-model-item :label-col="{ span: 12 }" label="车辆装卸责任条款(每次事故及累计赔偿限额：10万)">
              <a-select placeholder="请选择" :disabled="disabledAll" style="width: 280px" class="select_" :value="countData.add0005" @change="value => changeData(value, 'add0005')">
                <a-select-option v-for="item in CLZXoptions" :key="item.value + 'add0005'" :value="item.value">{{ item.name }}</a-select-option>
              </a-select>
              <span style="color: #fe8f2d">&nbsp;&nbsp;&nbsp;加收保费20元</span>
            </a-form-model-item>
          </div>
          <!-- 客人财产责任条款（每一客人限额：5000元） -->
          <div class="form_item">
            <a-form-model-item :label-col="{ span: 12 }" label="客人财产责任条款(每一客人限额：5000元)">
              <a-select placeholder="请选择" :disabled="disabledAll" style="width: 280px" class="select_" :value="countData.add0006" @change="value => changeData(value, 'add0006')">
                <a-select-option v-for="item in KRCCZRoptions" :key="item.value + 'add0006'" :value="item.value">{{ item.name }}</a-select-option>
              </a-select>
              <span style="color: #fe8f2d">&nbsp;&nbsp;&nbsp;加收保费70元</span>
            </a-form-model-item>
          </div>
          <!-- 出租人责任条款 -->
          <div class="form_item">
            <a-form-model-item :label-col="{ span: 12 }" label="出租人责任条款">
              <a-select placeholder="请选择" :disabled="disabledAll" style="width: 280px" class="select_" :value="countData.add0007" @change="value => changeData(value, 'add0007')">
                <a-select-option v-for="item in CZRZRoptions" :key="item.value + 'add0007'" :value="item.value">{{ item.name }}</a-select-option>
              </a-select>
              <span style="color: #fe8f2d">&nbsp;&nbsp;&nbsp;加收保费50元</span>
            </a-form-model-item>
          </div>
          <p class="p-header">免费扩展条款</p>
          <!-- 广告及装饰装置责任条款 -->
          <div class="form_item" v-for="(freeExtension, i) in freeExtensionClause" :key="i">
            <a-form-model-item :label-col="{ span: 12 }" :label="freeExtension.name">
              <a-select placeholder="请选择" :disabled="disabledAll" style="width: 280px" class="select_" :value="countData[freeExtension.value]" @change="value => changeData(value, freeExtension.value)">
                <a-select-option v-for="item in FJXoptions" :key="item.value + freeExtension.value" :value="item.value">{{ item.name }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </div>
        </div>
        <div class="btn_list">
          <a-button class="calBtn_" type="primary" @click="countPremiumSum" :disabled="disabledAll">刷新试算</a-button>
          <a-button style="margin-bottom: 50px" class="calBtn_" type="primary" v-if="!agreementRead" @click="goplicy" :disabled="disabledAll">去投保</a-button>
        </div>
      </div>
    </a-form-model>
  </div>
</template>

<script>
import moment from 'moment';
import { monthOptions } from '../js/utilsdictOptions.js';
import { riskinfoMixin } from '@/mixins/riskinfoMixin.js';
export default {
  mixins: [riskinfoMixin],
  props: {
    YYXZOptions: {
      //营业性质
      default: [],
    },
    disabledAll: {
      default: false,
    },
  },
  data() {
    return {
      monthOptions,
      allData: {},
      premiumSum: 0, //总保费
      planOffsetDay: 0,
      //免费扩展条款
      freeExtensionClause: [
        { name: '广告及装饰装置责任条款', value: 'GGZS' },
        { name: '急救费用条款', value: 'JJFY' },
        { name: '火灾和爆炸责任条款', value: 'HZBZ' },
        { name: '食品、饮料责任条款', value: 'SPYLZR' },
        { name: '锅炉及压力容器爆炸扩展条款', value: 'GLYLBZ' },
        { name: '指定公估人条款', value: 'ZDGGR' },
        { name: '附加火灾、爆炸、烟熏、水损责任保险', value: 'HZBZSS' },
        { name: '灭火及所致水损责任条款', value: 'MHZSS' },
        { name: '交叉责任条款A', value: 'JXZRA' },
        { name: '放弃追偿条款', value: 'FQZC' },
        { name: '建筑物改变条款(每次事故及累计赔偿限额：5万)', value: 'JZWGB' },
        { name: '人身侵害责任条款', value: 'RSQH' },
        { name: '承租人责任条款', value: 'ZHZR' },
        { name: '电梯责任条款', value: 'DTZR' },
      ],
      // 测算要提交的数据
      countData: {
        effectiveDate: '', // 保单生效时间
        expireDate: '', //保单终止时间
        bracket: '1', //月份
        occupationcodesh: undefined, //营业性质
        area: '', //营业面积
        main0001: undefined, //公众责任险保额（每次事故及累计赔偿限额）
        main0003: '', //赔偿限额
        GGZS: '1', //广告及装饰装置责任条款
        JJFY: '1', //急救费用条款
        HZBZ: '1', //火灾和爆炸责任条款
        SPYLZR: '1', //食品、饮料责任条款
        GLYLBZ: '1', //锅炉及压力容器爆炸扩展条款
        ZDGGR: '1', //指定公估人条款
        HZBZSS: '1', //附加火灾、爆炸、烟熏、水损责任保险
        MHZSS: '1', //灭火及所致水损责任条款
        JXZRA: '1', //交叉责任条款A
        FQZC: '1', //放弃代位追偿扩展条款
        JZWGB: '1', //建筑物改变条款(每次事故及累计赔偿限额：5万)
        RSQH: '1', //人身侵害责任条款
        ZHZR: '1', //承租人责任条款
        DTZR: '1', //电梯责任条款
        add0004: '0', //契约责任扩展条款B(每次事故及累计赔偿限额：50万)
        add0005: '0', //车辆装卸责任条款（每次事故及累计赔偿限额：10万）
        add0006: '0', //客人财产责任条款（每一客人限额：5000元）
        add0007: '0', //出租人责任条款
      },
      // 校验规则
      rules: {
        occupationcodesh: [{ required: true, message: '请选择营业性质', trigger: 'blur' }],
        area: [{ required: true, message: '请填写营业面积', trigger: 'blur' }],
        main0001: [{ required: true, message: '请填写公众责任', trigger: 'blur' }],
        main0003: [{ required: true, message: '每人赔偿限额', trigger: 'change' }],
      },
      //提交data
      data: {},
      planType: 'A',
      creator: '1',
      productCode: '',
      plan: '',
      userParams: '',
      FJXoptions: [
        { value: '0', name: '否' },
        { value: '1', name: '是' },
      ],
      QYZRBoptions: [
        { value: '0', name: '否' },
        { value: '500000', name: '是' },
      ],
      CLZXoptions: [
        { value: '0', name: '否' },
        { value: '100000', name: '是' },
      ],
      KRCCZRoptions: [
        { value: '0', name: '否' },
        { value: '5000', name: '是' },
      ],
      CZRZRoptions: [
        { value: '0', name: '否' },
        { value: '1', name: '是' },
      ],
    };
  },
  computed: {
    // 险种的数组
    riskInfos() {
      let infos = [
        { riskCode: 'main0001', dutyCode: 'main0001', amount: this.countData.main0001 }, //公众责任险保额（每次事故及累计赔偿限额）
        { riskCode: 'main0002', dutyCode: 'main0002', amount: this.countData.main0001 }, //每次事故赔偿限额---跟公众责任保额一样
        { riskCode: 'main0003', dutyCode: 'main0003', amount: this.countData.main0003 }, //赔偿限额
        { riskCode: 'HZBZ', dutyCode: 'HZBZ', amount: this.countData.HZBZ }, //火灾和爆炸责任条款
        { riskCode: 'GGZS', dutyCode: 'GGZS', amount: this.countData.GGZS }, //广告及装饰装置责任条款
        { riskCode: 'JJFY', dutyCode: 'JJFY', amount: this.countData.JJFY }, //急救费用条款
        { riskCode: 'SPYLZR', dutyCode: 'SPYLZR', amount: this.countData.SPYLZR }, //食品、饮料责任条款
        { riskCode: 'GLYLBZ', dutyCode: 'GLYLBZ', amount: this.countData.GLYLBZ }, //锅炉及压力容器爆炸扩展条款
        { riskCode: 'ZDGGR', dutyCode: 'ZDGGR', amount: this.countData.ZDGGR }, //指定公估人条款
        { riskCode: 'HZBZSS', dutyCode: 'HZBZSS', amount: this.countData.HZBZSS }, //附加火灾、爆炸、烟熏、水损责任保险
        { riskCode: 'MHZSS', dutyCode: 'MHZSS', amount: this.countData.MHZSS }, //灭火及所致水损责任条款
        { riskCode: 'JXZRA', dutyCode: 'JXZRA', amount: this.countData.JXZRA }, //交叉责任条款A
        { riskCode: 'FQZC', dutyCode: 'FQZC', amount: this.countData.FQZC }, //放弃代位追偿扩展条款
        { riskCode: 'JZWGB', dutyCode: 'JZWGB', amount: this.countData.JZWGB }, //建筑物改变条款(每次事故及累计赔偿限额：5万)
        { riskCode: 'RSQH', dutyCode: 'RSQH', amount: this.countData.RSQH }, //人身侵害责任条款
        { riskCode: 'ZHZR', dutyCode: 'ZHZR', amount: this.countData.ZHZR }, //承租人责任条款
        { riskCode: 'DTZR', dutyCode: 'DTZR', amount: this.countData.DTZR }, //电梯责任条款
        { riskCode: 'add0004', dutyCode: 'add0004', amount: this.countData.add0004 }, //契约责任扩展条款B(每次事故及累计赔偿限额：50万)
        { riskCode: 'add0005', dutyCode: 'add0005', amount: this.countData.add0005 }, //车辆装卸责任条款（每次事故及累计赔偿限额：10万）
        { riskCode: 'add0006', dutyCode: 'add0006', amount: this.countData.add0006 }, //客人财产责任条款（每一客人限额：5000元）
        { riskCode: 'add0007', dutyCode: 'add0007', amount: this.countData.add0007 }, //出租人责任条款
      ];
      return infos;
    },
    applicantInfoExpireDate() {
      var mon = this.countData.bracket;
      let t2;
      if (this.countData.effectiveDate) {
        t2 = moment(this.countData.effectiveDate).add(mon, 'months').subtract(1, 's');
      }
      return t2;
    },
  },
  watch: {},
  created() {
    const { u, p, planCode } = this.$route.query;
    this.creator = u;
    this.productCode = p;
    this.plan = planCode;
    this.userParams = {
      //从地址中获取
      userId: u,
      productCode: p,
    };
  },
  mounted() {},
  methods: {
    moment,
    busOnDataMethod() {
      let data = this.$lodash.cloneDeep(this.$parent.$refs.policyInfo.submitdata);
      this.$nextTick(() => {
        this.countData.effectiveDate = data.salPolicy.effectiveDate ? moment(data.salPolicy.effectiveDate, 'YYYY-MM-DD') : '';
        this.countData.expireDate = moment(this.applicantInfoExpireDate, 'YYYY-MM-DD');
        this.countData.area = data.salPolicyHolder.area;
        this.countData.occupationcodesh = data.salPolicyHolder.occupationcodesh;
        this.countData.bracket = data.salPolicy.bracket;
        this.premiumSum = data.salPolicy.totalPremium;
        console.log(data, 9999);
        data.riskInfos.forEach(e => {
          this.countData[e.riskCode] = e.amount.toString();
        });
      });
    },
    //处理时间的
    effectiveDateChange(date1, date) {
      this.countData.effectiveDate = date;
    },
    busDatehander() {
      this.changeData();
    },
    disabledDate(current) {
      var dd = new Date();
      dd.setDate(dd.getDate() + 1); //获取AddDayCount天后的日期
      var y = dd.getFullYear();
      var m = dd.getMonth() + 1 < 10 ? '0' + (dd.getMonth() + 1) : dd.getMonth() + 1; //获取当前月份的日期，不足10补0
      var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate(); //获取当前几号，不足10补0
      var time = y + '-' + m + '-' + d;
      var currents = moment(time);
      return current < currents || current > moment(currents).add(1, 'year');
    },
    // 去投保
    goplicy() {
      if (!this.countData.main0001) {
        this.$message.error('请先选择险种信息再去投保！', 2);
        return;
      }
      this.$store.commit('setAgreement', true);
    },
    // 改变试算的数据
    changeData(value, param) {
      this.$nextTick(() => {
        if (param == 'main0001') {
          //主险
          let mod = value % 500000;
          if (mod) {
            value -= mod;
          }
          value = value < 500000 ? 500000 : value;
          this.countData.main0003 = value;
        }
        // if (!value || !param) return;
        this.countData[param] = value;
        this.data = {
          riskInfos: this.riskInfos.filter(item => item.amount > 0),
          salPolicy: {
            planCode: this.plan,
            creator: this.creator,
            bracket: this.countData.bracket, //保费期限
            productCode: this.productCode, //产品code
            effectiveDate: this.countData.effectiveDate ? moment(this.countData.effectiveDate).format('YYYY-MM-DD') : '',
            expireDate: this.applicantInfoExpireDate ? moment(this.applicantInfoExpireDate).format('YYYY-MM-DD') : '',
          },
          salPolicyExt: {
            isworkheightinvolved: '2',
          },
          salPolicyHolder: {
            addfifty: '2', // 测算类型
            stature: '2', //是否高空（2-否，1-是）
            occupationcodesh: this.countData.occupationcodesh, //营业性质
            area: this.countData.area, //营业面积
          },
        };
        let arrData = this.$lodash.cloneDeep(this.data);
        console.log(arrData, '传过来的数据');
        this.allData = { ...arrData };
        this.$nextTick(() => {
          this.$parent.$refs.policyInfo.busDataMethod();
        });
      });
    },
    //保费试算
    countPremiumSum() {
      this.changeData();
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.$api.calPremiumEmployer(this.allData).then(res => {
            if (res.data.content) {
              this.premiumSum = res.data.content.totalPremium;
            } else {
              this.$message.error(res.data.returnMsg + '错误');
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.policy {
  display: none;
}
.calTxt_ {
  font-size: 18px !important;
  font-weight: bold !important;
  color: #666666;
}
.pre-box {
  margin-top: 15px;
}
.risk_ {
  width: 60%;
}
.btn_list {
  margin-top: 20px;
  display: flex;

  .calBtn_ {
    margin-right: 30px;
  }
}
.flex_ {
  display: flex;
  flex-wrap: wrap;
}
.form_item {
  display: flex;
  justify-content: space-between;
  width: 100%;
  color: #333;
  margin-bottom: -10px;

  &.width_50 {
    width: 50%;
  }

  &.width_40 {
    width: 40%;
  }

  &.width_60 {
    width: 60%;
  }

  > label {
    white-space: nowrap;
    margin-right: 10px;
    margin-top: 15px;
  }

  .right_ {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;

    .select_ {
      margin-top: 10px;
    }

    .check_item {
      display: flex;
      align-items: center;
      margin-right: 10px;
      margin-top: 10px;

      &.on {
        label {
          border-color: #fe8f2d;
        }
      }

      label {
        // border: 1px solid #d9d9d9;
        padding: 3px 10px;
        border-radius: 3px;
        margin-right: 5px;
      }

      &.s_input input {
        width: 50px;
      }

      input {
        width: 150px;
        margin-right: 5px;
      }
    }
  }
}
.p-header {
  width: 100%;
  font-weight: bold;
  font-size: 15px;
  margin-bottom: 0;
}

.form_item {
  margin-bottom: -10px;
  .ant-form-item {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
}
.aftertext {
  position: relative;
}
.aftertext::after {
  content: '公众责任累计赔偿限额不能小于50万且不能超过3000万！';
  position: absolute;
  color: #fe8f2d;
  top: 14px;
  right: -300px;
  z-index: 2;
}
.tiaokuan_list {
  line-height: 24px;
}
</style>